import './configView';



// WEBPACK FOOTER //
// ./plugins/digital_slide_archive/web_client/main.js